<svg
  [style.opacity]="opacity"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 16 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  @if (hasGradient) {
  <defs>
    <linearGradient
      [attr.id]="gradientId"
      gradientUnits="userSpaceOnUse"
      x1="0"
      y1="0"
      x2="16"
      y2="18"
    >
      <stop offset="0%" [style.stop-color]="startColor" />
      <stop offset="100%" [style.stop-color]="endColor" />
    </linearGradient>
  </defs>
  }
  <path
    d="M0 17.9998V13.2916L1.65515 0H14.8464V3.28302L12.3615 13.2917V18L0 17.9998ZM5.98512 3.53495H10.1826V2.61279H5.98512V3.53495ZM13.4704 17.9993V12.872L15.2006 5.50497L16 12.2483V17.9993H13.4704Z"
    [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : color || defaultColor"
  />
</svg>
